import angular from "angular";

import "angular-messages";
import "ng-dialog";
import "ng-dialog/css/ngDialog.css";
import "ng-dialog/css/ngDialog-theme-default.css";
import "../mailgun";

angular
  .module("ticketco/common", ["ngDialog", "ngMessages", "tcMailgun"])
  .config(function (tcMailgunProvider, ngDialogProvider) {
    ngDialogProvider.setDefaults({
      controllerAs: "form",
      closeByDocument: false,
    });

    tcMailgunProvider.setup({
      key: "pubkey-9d56fbdecaceff8b58e0d39736f54436",
    });
  })
  .run(function ($http) {
    $http.defaults.headers.common = {
      Accept: "application/json",
    };
  });
